import ApiHandler from './ApiHandler';

export default {
    postReferences: data => ApiHandler.post('/references', data),
    getReferences: userId => ApiHandler.get(`/references/${userId}`)
};
